import { GivelifyButton } from '@givelify/ui';
import { styled } from '@mui/material';

export const NotificationWrapper = styled('div')({
    marginTop: 32,
});

export const CreateEnvelopeButton = styled(GivelifyButton)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        width: '100%',
    },
}));
